import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    maxHeight: 'calc(100svh - 200px)',
    overflow: 'auto',
    scrollbarWidth: 'none',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.nearWhite
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#B64FCD',
      borderRadius: 0
    }
  },

  folderButton: {
    marginRight: '8px'
  },

  table: {
    flex: '1',
    display: 'grid',
    gridRowGap: '0.5rem',
    borderCollapse: 'separate',
    tableLayout: 'fixed',
    minWidth: '100%',
    alignItems: 'center',
    borderSpacing: '0px 0.5rem',
    paddingRight: 20,
    // use this again when we have document performance ready.
    // gridTemplateColumns: `
    //         minmax(150px, 3fr)
    //         minmax(100px, 1fr)
    //         minmax(100px, 1fr)
    //         minmax(185px, 1.5fr)
    //         minmax(90px, 1fr)
    //         minmax(100px, 1fr)
    //         minmax(25px, 0.5fr)`,

    gridTemplateColumns: `
            minmax(150px, 3fr)
            minmax(100px, 1fr)
            minmax(100px, 1fr)
            minmax(90px, 1fr)
            minmax(100px, 1fr)
            minmax(80px, 0.5fr)
            minmax(25px, 0.5fr)`,
    '& thead,tbody, tr': {
      display: 'contents'
    },

    '& tbody': {
      cursor: 'pointer'
    },

    '& td': {
      backgroundColor: 'white',
      height: '76px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer'
    },

    '& th': {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#F8D8FF',
      color: '#B64FCD',
      height: 36,
      borderBottom: 'solid 1px #B64FCD',
      userSelect: 'none',
      fontSize: theme.size.sm
    },

    '& th:first-of-type': {
      borderTopLeftRadius: '4px'
    },

    '& th:last-of-type': {
      borderTopRightRadius: '4px'
    },
    '& th, td': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    '& .Mui-checked': {
      color: '#B64FCD'
    }
  },

  tableHeader: {
    display: 'flex',
    alignItems: 'center',
    margin: '0.5rem 1rem',
    backgroundColor: '#F8D8FF',
    borderRadius: '4px 4px 0px 0px',
    color: '#B64FCD',
    height: 36,
    borderBottom: 'solid 1px #B64FCD',

    '& > div > div ': {}
  },

  tableHeaderCell: {},

  roleGroup: {
    margin: '0px 1rem',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr 1fr 1.5fr 1fr 1fr 0.5fr',
    gridTemplateRows: '1fr',
    gridGap: '0.5rem'
  }
}))

export default useStyles
